<template>
  <div class="md5-tool">
    <h1>MD5 加密工具</h1>
    
    <div class="converter-container">
      <!-- 输入区域 -->
      <div class="section">
        <h3>输入文本</h3>
        <el-input
          v-model="inputText"
          type="textarea"
          :rows="6"
          placeholder="请输入要加密的文本"
          @input="handleInput"
        />
      </div>

      <!-- 选项区域 -->
      <div class="options-section">
        <el-radio-group v-model="upperCase" @change="handleInput">
          <el-radio :label="true">大写</el-radio>
          <el-radio :label="false">小写</el-radio>
        </el-radio-group>
      </div>

      <!-- 结果区域 -->
      <div class="results-section">
        <div class="result-item">
          <span class="label">16位：</span>
          <el-input v-model="md5_16" readonly>
            <template #append>
              <el-button @click="copyText(md5_16)">复制</el-button>
            </template>
          </el-input>
        </div>
        
        <div class="result-item">
          <span class="label">32位：</span>
          <el-input v-model="md5_32" readonly>
            <template #append>
              <el-button @click="copyText(md5_32)">复制</el-button>
            </template>
          </el-input>
        </div>
      </div>

      <!-- 说明区域 -->
      <div class="info-section">
        <h3>说明</h3>
        <ul>
          <li>MD5 是一种常用的哈希算法，可以将任意长度的数据转换为固定长度的字符串</li>
          <li>16位 MD5 是 32位 MD5 的中间部分（第9位到第24位）</li>
          <li>MD5 是不可逆的，无法从 MD5 值反推原始内容</li>
          <li>主要用于数据完整性校验、密码加密存储等场景</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import md5 from 'crypto-js/md5'

const inputText = ref('')
const upperCase = ref(false)
const md5_16 = ref('')
const md5_32 = ref('')

const handleInput = () => {
  if (!inputText.value) {
    md5_16.value = ''
    md5_32.value = ''
    return
  }

  // 计算32位MD5
  let md5_32_result = md5(inputText.value).toString()
  
  // 根据大小写选项转换
  md5_32_result = upperCase.value ? md5_32_result.toUpperCase() : md5_32_result.toLowerCase()
  
  // 获取16位MD5（取32位MD5的中间部分）
  const md5_16_result = md5_32_result.substring(8, 24)

  md5_32.value = md5_32_result
  md5_16.value = md5_16_result
}

const copyText = async (text) => {
  if (!text) {
    ElMessage.warning('没有可复制的内容')
    return
  }
  
  try {
    await navigator.clipboard.writeText(text)
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败')
  }
}
</script>

<style scoped>
.md5-tool {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}

.converter-container {
  margin-top: 20px;
}

.section {
  margin: 20px 0;
}

.options-section {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}

.results-section {
  margin: 20px 0;
}

.result-item {
  display: flex;
  align-items: center;
  margin: 15px 0;
  gap: 10px;
}

.label {
  width: 60px;
  text-align: right;
  font-weight: bold;
}

.info-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.info-section ul {
  padding-left: 20px;
  margin: 10px 0;
}

.info-section li {
  margin: 8px 0;
  line-height: 1.5;
}

h3 {
  margin-bottom: 10px;
  color: #303133;
}

:deep(.el-input-group__append) {
  padding: 0;
}

:deep(.el-input-group__append button) {
  border: none;
  margin: 0;
  height: 100%;
}
</style> 